import React from 'react';
import { Box } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import { ReactComponent as EnvelopeIcon } from 'assets/icons/others/envelope.svg';
import {
  Caption,
  Header,
  SubHeader,
  WrapperBox,
} from './TailoredPricing.style-elements';
import EnterpriseFormContainer from './EnterpriseFormContainer';

interface TailoredPricingProps {
  onChange: (isValid: boolean) => void;
}
const TailoredPricing: React.FC<TailoredPricingProps> = ({ onChange }) => {
  return (
    <WrapperBox>
      <Box mb={4}>
        <Caption>{defaultLocales.upgradeYourPlan}</Caption>
      </Box>

      <Box mb={3}>
        <Box mb={1.8}>
          <EnvelopeIcon />
        </Box>
        <Header>{defaultLocales.tailoredPricingQuestion}</Header>
        <SubHeader>{defaultLocales.tellMoreAboutYourProject}</SubHeader>
      </Box>
      <EnterpriseFormContainer onChange={onChange} />
    </WrapperBox>
  );
};

export default TailoredPricing;
